import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /subsidiary is a container — redirect to the default child (/users) so
 * the outer sidebar's "Organization Settings" entry always lands on Users,
 * matching the existing platform/feature-flags pattern.
 */
export const Route = createFileRoute('/_authenticated/_tenant/subsidiary/')({
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/subsidiary/roles', search });
  },
});
